import { UserDashboard, WidgetItem } from '@vyce/core/src/types';

export const DORMANT_TEAM_MEMBERS_SYSTEM_NAME = 'dormant_team_members';

/** Workers are considered dormant if they haven't clocked in within this period. */
export const DORMANT_PERIOD_WEEKS = 4;

/** Default widget config so it shows for everyone until they hide it in Customize Dashboard. */
export const DORMANT_TEAM_MEMBERS_WIDGET: WidgetItem = {
  name: 'Dormant Team Members',
  system_name: DORMANT_TEAM_MEMBERS_SYSTEM_NAME,
  module_name: 'Time',
  type: 'custom',
  available: true,
  is_active: true,
  layout: {
    i: DORMANT_TEAM_MEMBERS_SYSTEM_NAME,
    h: 6,
    w: 6,
    x: 0,
    y: 0,
    isDraggable: true,
    isResizable: true,
  },
};

/**
 * Adds the Dormant Team Members widget to a Time dashboard by default, but only
 * when it is not already present — so once a user hides it in Customize Dashboard
 * (persisted with is_active: false) it is never re-injected.
 */
export const withDormantTeamMembersWidget = (time: UserDashboard | undefined): UserDashboard => {
  const widgets = time?.widgets ?? [];
  const alreadyPresent = widgets.some(
    widget => widget.system_name === DORMANT_TEAM_MEMBERS_SYSTEM_NAME
  );

  return {
    ...time,
    widgets: alreadyPresent ? widgets : [...widgets, DORMANT_TEAM_MEMBERS_WIDGET],
  };
};
